import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function TaskStats({ totalActualHours, averageProgress }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 4,
        mb: 2,
        flexWrap: "wrap",
      }}
    >
      <Typography variant="subtitle1">
        Total Manhour: <strong>{totalActualHours.toFixed(2)}</strong>
      </Typography>

      <Typography variant="subtitle1">
        Cummulative Progress: <strong>{averageProgress.toFixed(1)}%</strong>
      </Typography>
    </Box>
  );
}
